<template>
  <div class="dashboard">
    <div id="sidebar" style="z-index: 100 !important">
      <!---THE SideNavbar component--->
      <SideNavbarComponent></SideNavbarComponent>
    </div>

    <div id="body">
      <!---THE Navbar component--->
      <div id="navbar-section" style="z-index: 100">
        <Navbar></Navbar>
      </div>
      <div id="routerView" style="z-index: 99">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import Navbar from "../components/navbar-component.vue";
import SideNavbarComponent from "../components/side-navbar-component.vue";
import firebase from "firebase/app";
import "firebase/firestore";

export default {
  components: {
    Navbar,
    SideNavbarComponent,
  },
  data() {
    return {
      unsubscribe: () => {},
    };
  },

  methods: {
    async listenForPushNotifications() {
      // Let's check if the browser supports notifications
      if (!("Notification" in window)) {
        return this.$alert(
          "The Browser you are using does not support Desktop Notifications. For Better Experience, please use upgrade your Browser.",
          "Outdated Browser",
          {
            confirmButtonText: "OK",
            type: "warning",
            callback: () => {},
          }
        );
        // return this.showWarningMessage();
      } else if (Notification.permission === "denied") {
        return this.$alert(
          "Notifications are turned Off on your Browser. Please go to Site Settings and enable Notifications for better experience",
          "Notifications Turned Off",
          {
            confirmButtonText: "OK",
            type: "warning",
            callback: () => {},
          }
        );
      }

      try {
        const messaging = firebase.messaging();
        // messaging.
        let token = await messaging.getToken({
          vapidKey:
            "BOz8PqnFXWzf5sOChFMoFqFX5i8wSjLDFmXCM1YGIZmtj6sWiSzjXT5nzLuO10639p9xOqTGofFOLoCxUL2CHn4",
        });
        if (token) {
          try {
            //Send Token to DB to add it if it doesnt exist already
            if (this.$store.getters.isLoggedIn) {
              await this.$http.post("push-notifications-device-tokens/save", {
                deviceToken: token,
              });
            }
          } catch {
            //Ignore such errors for now
          }
        } else {
          this.$rollbar.warning(
            "LECTURER FRONT END: Unable to Get Device Token from Firebase yet user gave permissions"
          );
        }
      } catch (error) {
        //
        if (Notification.permission === "denied") {
          return this.$alert(
            "You have Turned Off Notifications. For Better User Experience, please go to Site Settings and enable Notifications.",
            "Notifications Turned Off",
            {
              confirmButtonText: "OK",
              type: "warning",
              callback: () => {},
            }
          );
        }
      }
    },

    listenForDeviceTokenChanges() {
      //This helps prefix dev tag to the ID for firebase to avoid logging out people accidentally
      const idPrefixer =
        process.env.NODE_ENV == "production" && !process.env.VUE_APP_IS_STAGING
          ? ""
          : "dev_";
      this.unsubscribe = firebase
        .firestore()
        .doc(
          `users/deviceTokens/staff/${idPrefixer}${this.$store.state.userId}`
        )
        .onSnapshot({ includeMetadataChanges: false }, (docSnapshot) => {
          if (docSnapshot.metadata.fromCache) return;
          if (
            !docSnapshot.exists ||
            docSnapshot.data().deviceToken !== this.$store.state.deviceToken
          ) {
            //Hit the logout endpoint too to clear resources there
            this.httpRequest({
              url: `/staff/logout?token=${this.$store.state.accessToken}`,
              method: "POST",
              showFullScreenLoader: false,
              isSilent: true,
            });

            this.$store.commit("LOGOUT_USER");

            this.showSuccessMessage(
              !docSnapshot.exists ? "Logout Successful" : "Logged in elsewhere",
              !docSnapshot.exists
                ? "You were logged out successfully"
                : "You were logged in on another Device"
            );
            return this.$router.replace({ path: "/login" });
          }
        });
    },
  },

  destroyed() {
    this.unsubscribe();
  },

  mounted() {
    this.listenForPushNotifications();
    //this.listenForDeviceTokenChanges();

    try {
      //If there's a redirect url for a page on the dashboard, then redirect to it
      if (
        store.state.redirectUrl &&
        store.state.redirectUrl.startsWith("/dashboard")
      ) {
        const redirectUrl = store.state.redirectUrl;
        store.commit("SET_REDIRECT_URL", null);
        this.$router.push(redirectUrl);
      }
    } catch (error) {
      //Ignore this error
    }
  },
};
</script>

<style scoped>
.noPadding {
  padding-top: 0px !important ;
}
.dashboard {
  position: relative;
}

.dashboard > #sidebar {
  width: 20%;
  position: fixed;
  left: 0px;
  top: 0px;
  bottom: 0px;
  min-height: 100vh;
  padding: 30px 0px;
  overflow-y: scroll;
}

.dashboard > #body {
  width: 80%;
  margin-left: 20%;
  background-color: #f6f6f6;
  min-height: 100vh;
  padding-top: 66px;
  padding-bottom: 50px;
}

.dashboard > #body #navbar-section {
  background-color: #f6f6f6;
  position: fixed;
  top: 0px;
  right: 0px;
  width: 80%;
  margin: 0px;
}

#routerView {
  min-height: 100vh;
  width: 100%;
}

/* width */
.dashboard > #sidebar::-webkit-scrollbar {
  width: 2px;
}

/* Track */
.dashboard > #sidebar::-webkit-scrollbar-track {
  /* background: #f1f1f1; */
  border-radius: 10px;
  background-color: #f6f6f6;
}

/* Handle */
.dashboard > #sidebar::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
.dashboard > #sidebar::-webkit-scrollbar-thumb:hover {
  background: #1f4ea1;
  border-radius: 10px;
}

/* width */
::-webkit-scrollbar {
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #f6f6f6;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #1f4ea1;
  border-radius: 10px;
}

/*##Device = Tablets, Ipads (portrait)##Screen = B/w 768px to 1024px*/
@media (min-width: 768px) and (max-width: 1024px) {
  .dashboard > #sidebar {
    width: 0%;
    position: static;
    display: none;
  }

  .dashboard > #body {
    width: 100%;
    margin-left: 0%;
    background-color: #f6f6f6;
    min-height: 100vh;
    padding-bottom: 50px;
  }

  .dashboard > #body > div {
    position: static;
    top: 0px;
    right: 0px;
    width: 100%;
  }

  .dashboard > #body #navbar-section {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
  }
}

/*##Device = Tablets, Ipads (landscape)##Screen = B/w 768px to 1024px*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .dashboard > #sidebar {
    width: 0%;
    position: static;
    display: none;
  }

  .dashboard > #body {
    width: 100%;
    margin-left: 0%;
    background-color: #f6f6f6;
    min-height: 100vh;
    padding-bottom: 50px;
  }
  .dashboard > #body > div {
    position: static;
    top: 0px;
    right: 0px;
    width: 100%;
  }
  .dashboard > #body #navbar-section {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
  }
}

/*##Device = Low Resolution Tablets, Mobiles (Landscape) ##Screen = B/w 481px to 767px*/
@media (min-width: 481px) and (max-width: 767px) {
  .dashboard > #sidebar {
    width: 0%;
    position: static;
    display: none;
  }

  .dashboard > #body {
    width: 100%;
    margin-left: 0%;
    background-color: #f6f6f6;
    min-height: 100vh;
    padding-bottom: 50px;
  }
  .dashboard > #body > div {
    position: static;
    top: 0px;
    right: 0px;
    width: 100%;
  }
  .dashboard > #body #navbar-section {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
  }
}

/*##Device = Most of the Smartphones Mobiles (Portrait) ##Screen = B/w 320px to 479px*/
@media (min-width: 320px) and (max-width: 480px) {
  .dashboard > #sidebar {
    width: 0%;
    position: static;
    display: none;
  }

  .dashboard > #body {
    width: 100%;
    margin-left: 0%;
    background-color: #f6f6f6;
    min-height: 100vh;
    padding-bottom: 50px;
  }
  .dashboard > #body #navbar-section {
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
  }
}
</style>
